"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDatasetRequestToJSON = exports.CreateDatasetRequestFromJSONTyped = exports.CreateDatasetRequestFromJSON = exports.instanceOfCreateDatasetRequest = void 0;
/**
 * Check if a given object implements the CreateDatasetRequest interface.
 */
function instanceOfCreateDatasetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "integrationIds" in value;
    return isInstance;
}
exports.instanceOfCreateDatasetRequest = instanceOfCreateDatasetRequest;
function CreateDatasetRequestFromJSON(json) {
    return CreateDatasetRequestFromJSONTyped(json, false);
}
exports.CreateDatasetRequestFromJSON = CreateDatasetRequestFromJSON;
function CreateDatasetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'integrationIds': json['integration_ids'],
    };
}
exports.CreateDatasetRequestFromJSONTyped = CreateDatasetRequestFromJSONTyped;
function CreateDatasetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'integration_ids': value.integrationIds,
    };
}
exports.CreateDatasetRequestToJSON = CreateDatasetRequestToJSON;
